// src/features/staff/pages/StaffDetailsPage/components/StaffStamkortTab.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import {
  BadgeOutlined as BadgeIcon,
  CameraAlt as CameraAltIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import { format } from 'date-fns';
import LocalizedDateDistance from '../../../../../i18n/LocalizedDateDistance';
import StaffTabSection from './StaffTabSection';

// A date with how long ago it was on hover
function DateValue({ date }) {
  return (
    <Tooltip title={<LocalizedDateDistance date={date} />}>
      <span>{format(new Date(date), 'dd.MM.yyyy')}</span>
    </Tooltip>
  );
}

function Field({ label, children }) {
  return (
    <Box minWidth={0}>
      <Typography variant="caption" color="text.secondary" component="div">{label}</Typography>
      <Typography variant="body2" component="div" sx={{ overflowWrap: 'anywhere' }}>{children}</Typography>
    </Box>
  );
}

/** The staff member's basic details, with the profile picture and password actions */
export default function StaffStamkortTab({ staffMember, canUpdate, canUploadFiles, onChangePicture, onResetPassword }) {
  const { t } = useTranslation(['staff']);

  return (
    <StaffTabSection
      icon={BadgeIcon}
      title={t('staff:tabs.stamkort')}
      fill
      actions={canUpdate && (
        <>
          {canUploadFiles && (
            <Button variant="outlined" startIcon={<CameraAltIcon />} onClick={onChangePicture}>
              {t('staff:profile_picture.button')}
            </Button>
          )}
          <Button variant="outlined" startIcon={<LockIcon />} onClick={onResetPassword}>
            {t('staff:profile.reset_password')}
          </Button>
        </>
      )}
    >
      <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(220px, 1fr))" gap={4}>
        <Field label={t('staff:labels.name')}>{staffMember.name}</Field>
        <Field label={t('staff:labels.hire_date')}>
          {staffMember.hire_date ? <DateValue date={staffMember.hire_date} /> : '—'}
        </Field>
        <Field label={t('staff:labels.last_login')}>
          {staffMember.last_login ? <DateValue date={staffMember.last_login} /> : '—'}
        </Field>
        <Field label={t('staff:labels.created')}>
          {staffMember.created_at ? <DateValue date={staffMember.created_at} /> : '—'}
        </Field>
        <Field label={t('staff:labels.staff_id')}>
          <Box component="span" fontFamily="monospace">{staffMember.staff_member_id}</Box>
        </Field>
      </Box>
    </StaffTabSection>
  );
}
